{
    "api_keys": {
        "generate": "API-Schlüssel erstellen",
        "saved": "Ich habe den API-Schlüssel gespeichert",
        "copy": "Kopieren"
    },
    "add": "Hinzufügen",
    "request": {
        "create": "Neuer Antrag",
        "edit": "Antrag bearbeiten",
        "save": "Antrag speichern",
        "submit": "Antrag einreichen",
        "delete": "Löschen",
        "export": {
            "title": "Export",
            "submit": "Download"
        },
        "item": {
            "add": "Artikel hinzufügen",
            "remove": "Artikel löschen"
        },
        "pause": "Abonnement pausieren",
        "unpause": "Abonnement reaktivieren",
        "subscription_history": "Abonnement Historie",
        "add_existing": "Existierenden Antrag hinzufügen",
        "delete_all_items": "Alle Artikel entfernen",
        "sync": "Synchronisieren",
        "sync_now": "Jetzt synchronisieren.",
        "reset_status": "Status zurücksetzen",
        "restore": "Wiederherstellen",
        "link_fields": "Felder koppeln",
        "unlink_fields": "Felder entkoppeln",
        "generate_request": "Antrag erstellen",
        "show_datev_import_protocol": "DUO Import Protokoll",
        "folder": {
            "add": "Neuen Antrag erstellen",
            "attach": "Antrag hinzufügen",
            "edit": "Reise bearbeiten",
            "delete": "Reise löschen",
            "archive": "Reise archivieren",
            "unarchive": "Reise aus-archivieren",
            "attach_expense": "Zu Reise hinzufügen",
            "detach": "Aus Reise entfernen",
            "status": {
                "draft": {
                    "confirm": "Einreichen",
                    "reject": "Löschen"
                },
                "invoice_pending": {
                    "confirm": "Freigeben",
                    "reject": "Ablehnen"
                },
                "approved": {
                    "confirm": "Prüfung bestätigen",
                    "reject": "Ablehnen"
                }
            }
        },
        "add_to_folder": "Zu Reise hinzufügen",
        "attach_to_folder": "Zu Reise hinzufügen",
        "add_request_to_folder": "Antrag zu Reise hinzufügen",
        "attach_discount": "Skonto"
    },
    "purchase_request": {
        "create": "Neuer Kaufantrag",
        "edit": "Kaufantrag bearbeiten"
    },
    "inbox_invoice": {
        "delete": "Löschen",
        "preview": "Vorschau",
        "move": "Verschieben",
        "assign": "Zuweisen",
        "unassign": "Zuweisung aufheben",
        "retry_ocr": "OCR wiederholen",
        "new_expense": "Neuer Antrag",
        "attach": "Rechnung dem Antrag zuweisen",
        "search": "Suche...",
        "inbox": "Eingang",
        "download": "Herunterladen",
        "attach_to_request": "Rechnung dem Antrag zuweisen",
        "select_type": "Typ auswählen"
    },
    "invoice_request": {
        "create": "Neuer Rechnungsantrag",
        "create_for_po": "Neuer Rechnungsantrag zu Bestellung #{{ poNumber }}",
        "edit": "Rechnungsantrag bearbeiten"
    },
    "subscription_request": {
        "create": "Neues Abonnement",
        "edit": "Abonnement bearbeiten"
    },
    "reimbursement_request": {
        "create": "Neuer Rückerstattungsantrag",
        "edit": "Rückerstattungsantrag bearbeiten"
    },
    "subscription": {
        "create": "Abonnement erstellen",
        "edit": "Abonnement bearbeiten",
        "submit": "Abonnement einreichen",
        "save": "Abonnement speichern",
        "subscription_can_not_be_deleted": "Dieses Abo kann nicht gelöscht werden, da bereits mindestens ein Antrag exportiert wurde. Alternativ kann das Abo pausiert werden."
    },
    "credit_card": {
        "create": "Neue Karten",
        "options": "Optionen"
    },
    "vendor": {
        "create": "Neuer Lieferant",
        "edit": "Lieferant bearbeiten",
        "save": "Speichern",
        "submit": "Neuen Lieferant erstellen",
        "set_rule": "Regel definieren",
        "icon_search": {
            "title": "Lieferantenlogo suchen",
            "confirm": "Logo benutzen",
            "search": "Logo suchen"
        }
    },
    "cost_center": {
        "create": "Neue Kostenstelle",
        "edit": "Kostenstelle bearbeiten",
        "save": "Kostenstelle speichern",
        "submit": "Neue Kostenstelle erstellen",
        "add_alternative_budget": "Alternatives Budget hinzufügen",
        "add_budget": "Abweichendes Budget hinzufügen"
    },
    "cost_center_group": {
        "create": "Neue Kostenstellengruppe",
        "edit": "Kostenstellengruppe bearbeiten",
        "save": "Kostenstellengruppe speichern",
        "submit": "Kostenstellengruppe erstellen"
    },
    "employee": {
        "create": "Neue:r Mitarbeiter:in",
        "edit": "Mitarbeiter:in bearbeiten",
        "save": "Mitarbeiter:in speichern",
        "submit": "Neue:n Mitarbeiter:in erstellen",
        "add_limit": "Limit hinzufügen",
        "invite": "Mitarbeiter:in einladen",
        "restore": "Wiederherstellen",
        "add_email_alias": "Email-Alias hinzufügen",
        "add_creditor_number_name": "Kreditorennummer für {{name}} hinzufügen",
        "add_creditor_number": "Kreditorennummer hinzufügen",
        "sync": "Synchronisieren"
    },
    "employee_absence": {
        "set_up": "Abwesenheit einrichten",
        "add_absence": "Abwesenheit",
        "select_replacement_approver": "Es ist dringend, wählen Sie eine:n andere:n Genehmiger:in",
        "absence": "Abwesenheit",
        "tooltip": "Ihre Abwesenheit wird automatisch über die Personio-Integration importiert.",
        "add_substitute": "Vertretung hinzufügen"
    },
    "user": {
        "create": "Neue:r Nutzer:in",
        "create_cta": "Neue:r Nutzer:in erstellen",
        "edit": "Nutzer:in bearbeiten",
        "add_to_company": "Zu Firma hinzufügen"
    },
    "user_profile": {
        "edit": "Profil bearbeiten",
        "save": "Speichern"
    },
    "password": {
        "change": "Passwort ändern",
        "update": "Passwort ändern"
    },
    "limit": {
        "add": "Limit erstellen",
        "remove": "Limit löschen"
    },
    "bug_report": {
        "create": "Feedback senden",
        "submit": "Feedback senden"
    },
    "tool_settings": {
        "edit": "Allgemeine Einstellungen bearbeiten",
        "save": "Speichern"
    },
    "business_address": {
        "edit": "Geschäftsadresse bearbeiten",
        "save": "Speichern"
    },
    "company_settings": {
        "edit": "Firmeneinstellungen bearbeiten",
        "save": "Speichern",
        "add_new": "Neue Firma hinzufügen",
        "mileage_distance_buffer": "Fahrtkostenerstattung: Entfernungspuffer"
    },
    "feature_settings": {
        "edit": "Feature-Einstellungen bearbeiten"
    },
    "expense_account_settings": {
        "expense_accounts": "Sachkonten",
        "save": "Speichern",
        "edit": "Aktualisieren"
    },
    "cost_center_2_settings": {
        "cost_center_2": "Kostenträger",
        "create": "Neu",
        "submit": "Erstellen"
    },
    "company_profile": {
        "add": "Zu Firma hinzufügen",
        "delete": "Profil löschen",
        "edit": "Profil bearbeiten",
        "restore": "Profil wiederherstellen"
    },
    "create": "Neu",
    "clear_all": "Zurücksetzen",
    "export": "Export",
    "retrieve": "Zurückholen",
    "edit": "Bearbeiten",
    "set": "Definieren",
    "login": "Login",
    "approve": "Freigeben",
    "reject": "Ablehnen",
    "request_changes": "Änderungen anfordern",
    "set_new_password": "Neues Passwort festlegen",
    "upload_new_image": "Neues Bild hochladen",
    "send_reminder": "Erinnerung senden",
    "follow_up": "Wiedervorlage",
    "reminder": "Erinnerung",
    "cancel_request": "Anfrage abbrechen",
    "upload_invoice": "Rechnung hochladen",
    "invoice": "Rechnung",
    "upload_contract": "Vertrag hochladen",
    "add_invoice": "Dokument hinzufügen",
    "add_purchase_order": "Bestellauftrag hinzufügen",
    "add_contract": "Vertrag hinzufügen",
    "or_drop_files": "Datei hier ablegen",
    "upload_delivery_note": "Lieferschein hochladen",
    "add_delivery_note": "Lieferschein hinzufügen",
    "replace_delivery_note": "Lieferschein ersetzen",
    "upload_company_logo": "Firmenlogo hochladen",
    "replace_company_logo": "Firmenlogo ändern",
    "upload_profile_picture": "Profilbild hochladen",
    "replace_profile_picture": "Profilbild ändern",
    "save": "Speichern",
    "save_view": "Ansicht speichern",
    "cancel_subscription_history": "Schließen",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "send": "Senden",
    "verify": "Verifizieren",
    "reset_password": "Passwort zurücksetzen",
    "change_password": "Neues Passwort erstellen",
    "upload_invoice_and_delivery_note": "Rechnung & Lieferschein hochladen",
    "mark_as_reviewed": "Prüfung bestätigen",
    "approve_vendor": "Lieferant genehmigen",
    "reject_vendor": "Lieferant ablehnen",
    "marked_as_paid": "Ist bezahlt worden",
    "payment_options": "Zahlungsmethoden",
    "payment": "Zahlung",
    "add_payment": "Zahlungsmethode hinzufügen",
    "sepa_xml": "SEPA-XML",
    "download_sepa": "SEPA-XML herunterladen",
    "download_non_sepa": "NON-SEPA-XML herunterladen",
    "generate_sepa": "SEPA-XML generieren",
    "generate_non_sepa": "NON-SEPA-XML generieren",
    "download_pdf": "PDF",
    "download_csv": "CSV",
    "mark_as_paid": "Wurde bezahlt",
    "upload_csv": "CSV hochladen",
    "matching": {
        "bank": {
            "title": "Bank Matching",
            "menu": "Via Bankverbindung",
            "submit": "Banktransaktionen laden"
        },
        "csv": {
            "title": "CSV Matching",
            "menu": "Via CSV-Upload",
            "submit": "Ausführen"
        },
        "upload_csv": "CSV hochladen",
        "title": "Matching",
        "submit": "Matching durchführen",
        "unmatch": "Unmatch",
        "add_transactions": "Transaktionen hinzufügen",
        "match": "Match",
        "create": "Erstellen",
        "cancel": "Abbrechen",
        "new_request": "Neue Antragsdaten",
        "add_possible_match": {
            "title": "Antrag hinzufügen",
            "submit": "Hinzufügen"
        },
        "show_all": "Alle anzeigen",
        "hide_low_matches": "Unwahrscheinliche verbergen",
        "hide_already_matched": "Bereits Gematchte verbergen",
        "show_already_matched": "Bereits Gematchte zeigen",
        "include_archived_expenses": "Archivierte berücksichtigen",
        "hide_archived_expenses": "Archivierte verstecken"
    },
    "submit": "Einreichen",
    "banking": {
        "add_bank_account": "Bankverbindung hinzufügen",
        "search_bank": {
            "title": "Bank Suche",
            "search": "Suchen"
        },
        "import": "Importieren",
        "update": {
            "save": "Speichern"
        },
        "pay_now": "Jetzt bezahlen",
        "pay_on_date": "Bezahlen am (Datum)",
        "connect_more_interfaces": "Weitere Interfaces verbinden",
        "schedule_payment": {
            "submit": "Zahlungstermin festlegen",
            "cancel": "Abbrechen"
        },
        "direct_payment": {
            "submit": "Zahlung bestätigen",
            "cancel": "Abbrechen"
        },
        "add_bank_connection": "Verbinden Sie ein Bankkonto in den Einstellungen",
        "resolve_consent": "jetzt Zustimmung erteilen",
        "manage_accounts": "Konten verwalten",
        "refresh_payment_status": "Zahlungsstatus aktualisieren",
        "force_payment_status_reset": "Erzwinge Zahlungsstatus Zurücksetzung"
    },
    "force_expense_payment_reset": "Erzwinge Zahlungsstatus Zurücksetzung",
    "expense_account": {
        "add": "Sachkonto hinzufügen"
    },
    "cost_center_2": {
        "add": "Kostenträger hinzufügen",
        "create": "Neuer Kostenträger",
        "submit": "Erstellen"
    },
    "change": "Ändern",
    "edit_plan": "Plan bearbeiten",
    "filter": "Filter",
    "apply_filter": "Filter anwenden",
    "cards": {
        "issue_card": "Karte ausstellen",
        "remove_card": "Karte entfernen",
        "edit": {
            "submit": "Karte aktualisieren"
        },
        "update_pin": "Finway PIN aktualisieren",
        "set_pin": "Finway PIN setzen",
        "pin_title": "Ihr finway PIN Nummer",
        "pin_remember_message": "Bitte merken Sie sich Ihre finway PIN und geben Sie diese nicht an Dritte weiter.",
        "or_retry": "oder versuchen Sie es nochmals.",
        "activate_card": "Karte aktivieren",
        "enroll_now": "Registrieren",
        "report_stolen": "Karte als gestohlen melden",
        "report_lost": "Karte als verloren melden",
        "weavr_terms_agree": "Ich habe die Bedingungen von Weavr gelesen und bin damit einverstanden.",
        "paynetics_terms_agree": "Ich habe die Bedingungen von Paynetics gelesen und bin damit einverstanden.",
        "finish_onboarding": "dieses Onboarding",
        "finish_onboarding_mobile": "dieses Onboarding.",
        "show_transfers": "Transfers anzeigen",
        "hide_transfers": "Transfers verstecken",
        "update_phone_number": "Mobiltelefonnummer aktualisieren",
        "request_limit_change": "Limitänderung anfordern",
        "limit_change_submit": "Einreichen",
        "unblock_pin": "PIN entsperren",
        "verify_email": "Email verifizieren"
    },
    "filter_option": {
        "select_all": "Alle auswählen",
        "deselect_all": "Alle abwählen"
    },
    "close": "Schließen",
    "wallet": {
        "wallet_details": "Wallet Details",
        "wallet": "Wallet",
        "withdrawal": "Geldauszahlung",
        "funding": "Wallet Aufladung",
        "submit": "Geld auszahlen",
        "direct_funding": "Überweisung via Bankanbindung",
        "bank_transfer": "Banküberweisung",
        "transfer_now": "Jetzt überweisen",
        "auth_factor": {
            "resolve_now": "hier geht es zum Registrierungsprozess"
        },
        "finish_setup": "Wallet fertigstellen"
    },
    "passcode": {
        "update": "Finway PIN aktualisieren",
        "recover": "Finway PIN wiederherstellen"
    },
    "upload_offer": "Angebot hochladen",
    "add_offer": "Angebot hinzufügen",
    "next_step": "Weiter",
    "finish": "Fertig",
    "back": "Zurück",
    "tax_settings": {
        "taxes": "MwSt."
    },
    "tax": {
        "add": "MwSt. hinzufügen"
    },
    "team_settings": {
        "teams": "Abteilungseinstellungen"
    },
    "team": {
        "add": "Abteilung hinzufügen"
    },
    "connect": "Verbinden",
    "continue": "Setup fortsetzen",
    "disconnect": "Entfernen",
    "datev_demo_mode": "DUO Demo",
    "datev_auto_export": "Auto-Export",
    "create_workflows": "Neuer Workflow",
    "workflow": {
        "create": "Neuer Workflow",
        "edit": "Workflow bearbeiten",
        "next_step": "Nächster Schritt"
    },
    "expense_split": {
        "save": "Änderungen speichern",
        "split": "Rechnung aufteilen",
        "edit": "Bearbeiten",
        "reset": "Änderungen zurücksetzen"
    },
    "period": "Intervall",
    "show": "Anzeigen",
    "chart_view": "Darstellung",
    "detail_view": "Detailansicht",
    "budget_view": "Budgetansicht",
    "liquidity": {
        "add_scenario": "Szenario hinzufügen",
        "edit_scenario": "Szenario bearbeiten",
        "delete_scenario": "Szenario löschen",
        "plan_transactions": "Transaktionen planen",
        "add_bank_account": "Bankverbindung hinzufügen"
    },
    "troubleshooting": {
        "clear_cache_and_cookies": "Cache und Cookies leeren."
    },
    "payment_settings": {
        "get_a_quote": "Angebot anfragen",
        "card_prices": "Kartenpreise",
        "sign_up": "Jetzt registrieren",
        "add_payment_method": "Zahlungsmethode hinzufügen"
    },
    "archive": {
        "do": "Archivieren",
        "undo": "Ausarchivieren",
        "load": "Archiv laden",
        "expense_search": "Suche nach bestimmten Ausgaben",
        "transaction_search": "Suche nach bestimmten Transaktionen"
    },
    "confirm": "Bestätigen",
    "sheet_template": "Vorlage-Datei",
    "document": "Ausgefüllte Vorlage-Datei",
    "upload": "Hochladen",
    "download": "Herunterladen",
    "upload_my_data": "Daten jetzt importieren",
    "import_result_log": "Ergebnisprotokoll",
    "bulk_payment": "Sammelüberweisung",
    "bulk_export": "Sammel-Export",
    "waiting": {
        "title": "Aktion wird durchgeführt"
    },
    "transaction_category": {
        "add": "Kategorie hinzufügen",
        "create_inflow": "Zahlungseingangs-Kategorie erstellen",
        "create_outflow": "Zahlungsausgangs-Kategorie erstellen",
        "new_inflow": "Neue Zahlungseingangs-Kategorie",
        "new_outflow": "Neue Zahlungsausgangs-Kategorie",
        "edit": "Kategorie bearbeiten",
        "title": {
            "create": "Kategorie hinzufügen",
            "edit": "Kategorie bearbeiten"
        }
    },
    "integrations": {
        "get_my_invoices": {
            "set_up": "GetMyInvoices aufsetzen",
            "save": "Speichern"
        },
        "personio": {
            "connect": "Verbinden",
            "update": "Aktualisieren",
            "manualSync": "Daten manuell synchronisieren",
            "save": "Speichern"
        }
    },
    "abort_setup": "Einrichtung abbrechen",
    "payment_method": {
        "save": "Speichern",
        "cancel": "Abbrechen"
    },
    "demo_url": "https://finway.de/upgrade-demo-vereinbaren/",
    "create_recurring_expense": {
        "create": "Wiederkehrenden Antrag erstellen",
        "submit": "Erstellen"
    },
    "per_diem_summary": "Eigenbeleg Verpflegungsmehraufwand",
    "mileage_summary": "Eigenbeleg Kilometerpauschale",
    "accept_sepa_debit_agreement": "Ich stimme der aktuellen Vereinbarung zur Lastschrift zu.",
    "role_settings": {
        "create_custom_role": "Benutzerdefinierte Rolle erstellen",
        "edit_custom_role": "Benutzerdefinierte Rolle bearbeiten"
    },
    "issue_finway_card": "finway-Karte ausstellen",
    "can_wait": "Ich kann warten",
    "expense_tag": {
        "create": "Tag hinzufügen",
        "add": "Tag erstellen"
    },
    "csv_settings_title": "Benutzerdefinierte CSV Vorlagen",
    "validation_results": "Validierungsergebnisse",
    "choose_this_instead": "Diesen Lieferanten wählen",
    "import_results": "Ergebnisse des Datenimports",
    "validate_data": "Daten validieren",
    "confirm_data_import": "Datenimport bestätigen",
    "approval_process": "Genehmigungsprozess",
    "folder_approval_process": "Reise-Genehmigungsprozess",
    "table": {
        "select_page": "Nur sichtbare Seite auswählen",
        "select_all": "Alle Seiten auswählen"
    },
    "download_invoices": "Rechnungen exportieren",
    "download_billable_invoices": "Nur weiterverrechenbar Rechnungen",
    "trip_folder": {
        "create": "Neue Reise",
        "edit": "Reisekosten aktualisieren",
        "submit": "Reise erstellen",
        "save": "Reise erstellen"
    },
    "sso": {
        "setup": "Erstellen",
        "update": "Aktualisieren",

        "deforce": {
            "title": "Verpflichtender SSO login zurücksetzen",
            "message": "Dies ermöglicht den Login mit email und passwort."
        },
        "login_with_x": "Einloggen mit {{key}}"
    },
    "update_through_ocr_continue": "Bestätigen",
    "regenerate_statement": "Statement neu erstellen",
    "re_authenticate": "Re-Authentifizierung",
    "reset_password_for_user": "Password zurücksetzen für Nutzer:in",
    "unblock_user": "Nutzer:in entsperren",
    "sync": "Synchronisieren",
    "sessions_logout": "Alle Sitzungen abmelden",
    "select": "Auswählen",
    "deselect": "Abwählen",
    "po_link": {
        "link_items": "Artikel verlinken",
        "auto_link_all": "Alle automatisch verknüpfen",
        "select_purchase_orders": "Bestellung auswählen",
        "clear_all": "Alles zurücksetzen",
        "submit_links": "Verknüpfungen einreichen",
        "unlink": "Verlinkung aufheben",
        "manage_links": "Verknüpfungen verwalten"
    },
    "view_document": "Dokument ansehen"
}
